var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstitutionCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 16V9H5V16H3ZM9 16V9H11V16H9ZM0 7V5L10 0L20 5V7H0ZM4.475 5H15.525L10 2.25L4.475 5ZM0 20V18H12.05C12.0833 18.35 12.125 18.6875 12.175 19.0125C12.225 19.3375 12.3 19.6667 12.4 20H0ZM15 12.25V9H17V11.25L15 12.25ZM18 23C16.85 22.7167 15.8958 22.0542 15.1375 21.0125C14.3792 19.9708 14 18.8167 14 17.55V15L18 13L22 15V17.55C22 18.8167 21.6208 19.9708 20.8625 21.0125C20.1042 22.0542 19.15 22.7167 18 23ZM17.275 20L20.75 16.55L19.7 15.5L17.275 17.875L16.3 16.9L15.25 17.975L17.275 20Z",
    fill: "#7D35FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutionCheckedIcon);
export default __webpack_public_path__ + "static/media/institution_checked_icon.656bf0a19444bc8aa4dced2f3b1c021b.svg";
export { ForwardRef as ReactComponent };